import React, { useContext, useEffect, useState } from "react";
import "./Testimonials.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { Context } from "../../../../utils/context";
import Common_Title from "../../../common_components/common_title/Common_Title";

// Parse HTML outside the component to prevent re-creation on every render
const HtmlToReactParser = require("html-to-react").Parser;
const htmlToReactParser = new HtmlToReactParser();

const Testimonials = () => {
  const { getData, imageUrl } = useContext(Context);
  const [clientReviews, setClientReview] = useState([]);

  const getClientReview = async () => {
    const res = await getData("/without-login/home/client-review");
    if (res?.success) {
      setClientReview(res.data);
    }
  };

  useEffect(() => {
    getClientReview();
  }, []);

  return (
    <section className="Testimonials_section">
      <div className="container">
        <div className="test_title text-center mb-3">
          <Common_Title title="Good Reviews " subTitle={"By Clients"} />
        </div>

        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          pagination={{ clickable: true }}
          // autoplay={{
          //   delay: 4000,
          //   disableOnInteraction: false,
          // }}
          loop={true}
          breakpoints={{
            768: { slidesPerView: 2, spaceBetween: 20 },
            1200: { slidesPerView: 2, spaceBetween: 30 },
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper testimonial_swiper"
        >
          {clientReviews?.map((job, index) => (
            <SwiperSlide key={job?.id || index}>
              <div className="testimonial_card ">
                  <div className="quote_icon">“</div>
                  <div className="review_content">
                    {htmlToReactParser.parse(job?.description)}
                  </div>
                  <div className="client_profile ">
                    <div className="img_wrapper">
                      <img
                        src={imageUrl + job?.image}
                        className="client_img"
                        alt={job?.name || "Client"}
                      />
                    </div>
                    <div className="client_info">
                      <h4 className="client_name">{job?.name}</h4>
                      <span className="client_tag">Verified Client</span>
                    </div>
                  </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
